import Loading from "../UI/Loading/Loading";

const HomeReroute = () => {
  return <Loading loading />
}
export default HomeReroute;